import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useCurrentUser, useAccessToken, useUpdateUser } from '@/features/auth/state/auth'
import api from '@/lib/api'
import { UpdateUserCepBody } from '@/types/user'

export function useUpdateUserCep() {
  const queryClient = useQueryClient()
  const user = useCurrentUser()
  const token = useAccessToken()
  const updateUser = useUpdateUser()

  return useMutation({
    mutationFn: async ({ body }: { body: UpdateUserCepBody }) => {
      if (!user || !token) throw new Error('Usuário ou token ausente')
      const response = await api.post(`/user/cep/${user.id}`, body, {
        headers: { Authorization: `Bearer ${token}` }
      })

      if (response.data) {
        const updatedUser = response.data?.data
        updateUser({
          cep: updatedUser?.cep ?? body.cep,
          id_address: updatedUser?.id_address ?? user.id_address ?? null
        })
        return response.data
      }
      throw new Error('Erro ao atualizar o CEP do usuário')
    },
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['user'] })
    }
  })
}
